import {
    FormControl,
    Grid,
    InputLabel,
    Select,
    TextField,
    MenuItem,
} from "@mui/material";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import styled from "styled-components";
import { PrimaryButton } from "../../Layouts/ButtonsControlled";
import { FormHeading } from "../../Layouts/Heading";
import * as yup from "yup";
import { useEffect } from "react";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
import {
    adderReset,
    CreateAdderMethod,
    GetAllServiceTypes,
    GetSingleAdderMethod
} from "../../Redux/AddersSlicev2/AddersSlicev2";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const CreateAdderv2Child = () => {
    const { parent_id } = useParams();
    const navigate = useNavigate();


    const dispatch = useDispatch();

    const { adder, isLoading, isError, errors, isSuccess } = useSelector(
        (state) => state.addersv2
    );
    const AdderVal = adder?.data || [];

    const validationSchema = yup.object({});
    const formik = useFormik({
        initialValues: {
            name: "",
            type: "children",
            parent_id: parent_id || 0,
            is_active: 1,
            submit: false
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            values.submit = true;
            const Form_Data = new FormData();
            Form_Data.append("type", values?.type);
            Form_Data.append("parent_id", values?.parent_id);
            Form_Data.append("is_active", values?.is_active);
            Form_Data.append("categories[0][name]", values?.name);

            await dispatch(CreateAdderMethod(Form_Data));
            await navigate("/dashboard/adders/v2/parent=" + parent_id);
            // await dispatch(adderReset());
        },
    });

    useEffect(() => {
        const GetAllServices = async () => {
            await dispatch(GetAllServiceTypes());
            // await dispatch(adderReset());
            // await GetAdderData();
        };
        GetAllServices();
    }, []);

    useEffect(() => {
        if (isError) {
            if (errors) {
                Object.keys(errors).forEach((key) => {
                    let error = errors[key][0];
                    toast.error(error);
                });
            }
            const reset = async () => {
                await dispatch(adderReset());
            };
            reset();
        }
    }, [dispatch, errors, isError]);

    useEffect(() => {
        if (isSuccess && formik.values?.submit) {
            toast.success("Created successfully");
            formik.values.name = "";
        }
    }, [formik.values, isSuccess]);

    const GetAdderData = async () => {
        await dispatch(GetSingleAdderMethod(parent_id));
        await dispatch(adderReset());
    };
    useEffect(() => {
        GetAdderData();
    }, [dispatch, parent_id]);

    return (
        <>
            {isLoading && <LoadingAnimation />}
            {!isLoading && (
                <FormContainer>
                    <FormHeading> Add Child  {AdderVal ? " To : " + AdderVal?.name : ""}  </FormHeading>
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container columns={12} spacing={3}>
                            {/* <Grid item mb={1} xs={12} md={6}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">
                                        Service Type
                                    </InputLabel>
                                    <Select
                                        id="service_type"
                                        name="service_type"
                                        label="Service Type"
                                        value={formik.values.service_type}
                                        onChange={formik.handleChange}
                                    >
                                        {allServices?.map((key, index) => (
                                            <MenuItem
                                                key={index}
                                                value={key.name}
                                            >
                                                {key.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid> */}
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="name"
                                    name="name"
                                    label="Name"
                                    value={formik.values.name}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.name &&
                                        Boolean(formik.errors.name)
                                    }
                                    helperText={
                                        formik.touched.name &&
                                        formik.errors.name
                                    }
                                />
                            </Grid>
                        </Grid>

                        <PrimaryButton fullWidth type="submit">
                            {isLoading ? "loading ... " : " Add New Adder"}
                        </PrimaryButton>
                    </form>
                </FormContainer>
            )}
        </>
    );
};

const FormContainer = styled.div`
    padding: 1rem;
`;
export default CreateAdderv2Child;
